import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=55f17814&scoped=true"
import script from "./ColorInput.vue?vue&type=script&lang=ts"
export * from "./ColorInput.vue?vue&type=script&lang=ts"
import style0 from "./ColorInput.vue?vue&type=style&index=0&id=55f17814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f17814",
  null
  
)

export default component.exports